import { FunctionComponent, ReactNode } from 'react';

import classes from './SettingsSection.module.scss';

interface SettingsSectionProps {
  title: string;
  hint: string;
  children: ReactNode;
}

export const SettingsSection: FunctionComponent<SettingsSectionProps> = ({
  title,
  hint,
  children,
}) => (
  <div className={classes['settings-section']}>
    <div className={classes['settings-section__header']}>
      <div className={classes['settings-section__title']}>{title}</div>
      <div className={classes['settings-section__hint']}>{hint}</div>
    </div>
    {children}
  </div>
);
